import { GridButtons } from "@/controls/buttons/GridButtons";
import { Arbor } from "@/pages/catalogs/models/Arbor";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";

type Props = {
	setSelectedRowData: (arbor: Arbor) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};
export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		// Hide
		{
			field: "RFIDTag",
			headerName: "Tag",
			hide: true,
		},
		{
			field: "Comments",
			headerName: "Comments",
			hide: true,
		},
		// Visible
		{
			field: "PartName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "LocationName",
			headerName: "Location",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "Stands",
			headerName: "Stand",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as Arbor,
				setShowModal: setShowModal,
				edit: false,
				showContextMenu: () =>
					showContextMenu(event, params.data, "arborContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			flex: 1,
			maxWidth: 180,
			autoHeaderHeight: true,
		},
	];
	return { columnDefs };
};
